import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'

import { Div, Button, NavigationHeader } from '@driftt/tide-core'

import { startImport } from 'api/imports'
import { tracking } from '@driftt/traffic-control'

import FileUpload from 'components/FileUpload'
import ContactImportMappings from 'components/ContactImportMappings'
import ImportInstructions from 'components/Imports/ImportInstructions'

import './style.css'

class CSVImport extends Component {

  state = {
    upload: null,
    mappings: null,
    importedFile: null
  }

  componentDidMount() {
    tracking.trackEvent('Contact Imports (New Import) - Page Viewed')
  }

  onClear = () => {
    this.setState({
      upload: null,
      mappings: null,
      importedFile: null
    })
  }

  onUpload = upload => {
    this.setState({
      upload: upload
    })
  }

  onUpdateMappings = mappings => {
    this.setState({
      mappings: mappings
    })
  }

  onStartImport = async () => {
    const { mappings, upload } = this.state

    try {
      const { data: importedFile } = await startImport(upload.id, mappings, upload.filename)
      this.setState({ importedFile })
    } catch (err) {
      console.log(err)
    }
  }

  render() {
    const { upload, mappings, importedFile } = this.state

    if (!!importedFile) {
      return <Redirect to="/imports/logs" />
    }

    return (
      <Div className="new-import">
        <NavigationHeader title="Import CSV">
          <Link to={`/imports/logs`} className="new-import--actions--log-link">Import logs</Link>
          <Link to="/imports">
            <Button type="subtle">Cancel</Button>
          </Link>
          <Button onClick={this.onStartImport} disabled={!mappings}>Finish</Button>
        </NavigationHeader>
        <FileUpload onUpload={this.onUpload} onClear={this.onClear} />
        <ContactImportMappings onChange={this.onUpdateMappings} upload={upload} />
        {!upload && <ImportInstructions />}
      </Div>
    )
  }
}

export default CSVImport
